/**
 * Site Configuration
 * Single source of truth for all editable company info.
 * Update values here instead of hunting through components.
 */

const siteConfig = {
  companyName: "Roach Home Improvement",
  companyNameFull: "Roach Home Improvement, LLC",
  // Main company line (Battle Creek HQ). Use this only where the surface is
  // company-wide — nav, footer, sitewide CTAs, Organization-level schema.
  // Anything scoped to a single city should use phoneForCity() below.
  phone: "(269) 420-6623",
  email: "",

  // Office locations. Each office has its own phone number as of July 2026.
  offices: [
    {
      address: "901 Capital Ave Northeast",
      city: "Battle Creek",
      state: "MI",
      zip: "49017",
      phone: "(269) 420-6623",
    },
    {
      address: "4331 Clyde Park Ave. SW",
      city: "Wyoming",
      state: "MI",
      zip: "49509",
      phone: "(616) 367-3700",
      // Google Maps "share -> embed" URL pinned to the office itself, supplied as
      // Figma comment #92 on the Wyoming frame (node 428:38). Offices without one
      // fall back to a generic city-centred map in the city page sidebar, so this
      // must stay per-office — a shared value would show the Wyoming branch on
      // all ~365 city pages.
      mapEmbedSrc:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28997.25303779472!2d-85.69757929091783!3d42.88500440129867!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8819b177ea473d39%3A0xd17637ff97edbecc!2sRoach%20Home%20Improvement%2C%20LLC!5e0!3m2!1sen!2sus!4v1785396914309!5m2!1sen!2sus",
    },
    {
      address: "2600 Airport Rd. Suite 100",
      city: "Jackson",
      state: "MI",
      zip: "49202",
      phone: "(517) 544-0401",
      // Figma comment #87 on the Jackson frame (node 414:47). See the Wyoming
      // entry above for why this is per-office rather than shared.
      mapEmbedSrc:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8512.709769385481!2d-84.46175086436948!3d42.272063797774926!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x883d312dd273f3e9%3A0x11ee11428c23adad!2sRoach%20Home%20Improvement%2C%20LLC!5e0!3m2!1sen!2sus!4v1785240176190!5m2!1sen!2sus",
    },
  ],

  // Slogan shown in footer
  slogan: "#1 Roofing and Home Improvement Contractor Serving West Michigan",

  // Social media URLs — leave empty string to hide the icon
  social: {
    facebook: "",
    instagram: "",
    google: "",
    yelp: "",
    youtube: "",
  },

  // Update these periodically as new reviews come in
  // Last updated: 2024-02
  reviewCount: 271,
  reviewAvg: 5,

  // FormIt IN form ID for lead gen
  formInitId: "yg5ybujubjr",
};

/**
 * The office that serves a given city, or undefined if we have no office there.
 * Matching is case- and whitespace-insensitive so it works with Contentful
 * city names and slugs alike.
 */
siteConfig.officeForCity = (city) => {
  const key = String(city || "").trim().toLowerCase();
  if (!key) return undefined;
  return siteConfig.offices.find((o) => o.city.toLowerCase() === key);
};

/**
 * Phone number to show for a given city. Cities we serve but have no office in
 * fall back to the main company line.
 */
siteConfig.phoneForCity = (city) => {
  const office = siteConfig.officeForCity(city);
  return office ? office.phone : siteConfig.phone;
};

/** "(616) 367-3700" -> "+16163673700", for tel: hrefs and schema.org telephone. */
siteConfig.phoneE164 = (phone) => {
  const digits = String(phone || siteConfig.phone).replace(/[^0-9]/g, "");
  return digits.length === 10 ? `+1${digits}` : `+${digits}`;
};

module.exports = siteConfig;
